<template>
	<div class="rounded">
		<paper-bid-edit
			:form="form"
			:active-futures="activeFutures"
			:trade="trade"
		/>

		<div class="bg-gray-100 p-6 flex justify-end">
			<ui-button
				:disabled="submitButtonDisabled"
				v-on:click="submitForm()"
				:label="submitButtonLabel"
			/>
		</div>
	</div>
</template>

<script>
let options = require("../../cropOptions");
export default {
	props: {
		reference: {
			type: Object,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		trade: {
			type: String,
			required: true,
		},
		redirect: {
			type: String,
			default: null,
		},
	},
	data() {
		let t = JSON.parse(JSON.stringify(this.reference));

		return {
			formMethod: this.$page.url,

			formAction:
				this.reference.type == "BID"
					? this.$route("paper.store_counter", { bidId: this.reference.id })
					: this.$route("bid.create", {
							targetType: this.reference.trade,
							targetId: this.reference.id,
					  }),

			form: Vue.observable(this.$inertia.form(t)),
			submitButtonDisabled: false,
		};
	},
	created() {
		/*
        this.form.quality.paper_fixed =
            this.currentHub.productGradeOptions[this.form.product.grade];
*/
		// set reference if required
		if (!this.form.reference) {
			this.form.reference = {};
		}
		if (this.reference.type == "BID") {
			this.form.reference.bid_id = this.reference.id;
		} else if (this.reference.type == "OFFER") {
			if (this.reference.trade == "buy") {
				this.form.reference.offer_buy_id = this.reference.id;
			} else {
				this.form.reference.offer_sell_id = this.reference.id;
			}
		}
	},
	computed: {
		/*
        futuresOptions() {
            let tickers = {
                RAPE: 'ECO',
                MAIZE: 'EMA',
            },
                desiredTicker = tickers[this.form.product.type] || 'EBM';
            return (this.activeFutures || []).filter(
                (f) => f.ticker_code == desiredTicker
            );
        },
        currentHub() {
            let filteredHub = options.standardHubs.filter(
                (h) => h.id == this.form.location.hub
            );

            return filteredHub[0] ? filteredHub[0] : null;
        },
        hubName() {
            return options.getLabel(this.form.location.hub, options.standardHubs);
        },
        gradeName() {
            return this.__(options.getLabel(
                this.form.product.grade,
                options.productGradeOptions
            ));
        },
        priceLabel() {
            return options.getLabel(this.form.price.type, [
                { id: "FLAT", name: this.__("Fixed price") },
                { id: "INDEXED", name: this.__("Premium-based indication") },
                { id: "BASIS", name: this.__("Premium") },
            ]);
        },
        productPriceFuture() {
            let future = this.activeFutures.filter(
                (f) => f.id == this.form.price.commodity_future_id
            );
            return future ? future[0] : null;
        },
        currentPriceEstimateIndexedPrice() {
            let basis = this.form.price.basis * 1,
                future = this.productPriceFuture;
            if (basis && future) {
                return basis + (future.euronext_price ?? future.last_price) * 1;
            } else {
                return null;
            }
        },
        referenceLabel() {
            if (this.trade == "SELL") {
                return this.__("Acc. demand");
            }
            else {
                return this.__("Acc. offer");
            }
        },*/
		submitButtonLabel() {
			if (this.trade == "SELL") {
				return this.__("Make a offer to the seller now!");
			} else {
				return this.__("Bid now!");
			}
		},
		/*
        bidExpiryOptions() {
            let d = new Date();
            return this.$cropOptions.bidExpiryOptions.filter((option) => {
                if (option.id == "TODAY_1830" && d.getHours() > 17) {
                    return false;
                } else {
                    return true;
                }
            });
        },
        dateTypeOptions() {
            return (this.currentHub) ? this.currentHub.dateTypeOptions : [];
        },
		*/
	},
	methods: {
		async submitForm() {
			let endpoint = this.formAction + "?iframe_modal=true",
				method = "patch", // always use patch for storing, even when creating
				that = this;

			// in case of single month, month_from should be null
			if (this.form.date.type == "MONTH") {
				this.form.date.month_from = null;
			}

			this.submitButtonDisabled = true;
			this.form.submit(method, endpoint, {
				preserveState: true,
				onSuccess(p) {
					console.log("SUCCESS SUBMISSION, got: ", p);
					that.$emit("close");
				},
				onFinish(e) {
					that.submitButtonDisabled = false;
					console.log("submit FINISH", method, endpoint, "got:", e);
					console.log("onFinish", that.onFinish, "REDIR", that.redirect);

					if (that.onFinish) {
						that.onFinish();
					} else if (that.redirect) {
						that.closeRedirect(that.redirect);
					} else if (that.success) {
						console.log("SUCCESS - closing modal");
						that.closeIframeModal();
					}
				},
			});
		},
		closeRedirect(url) {
			console.log("REDIRECT", url);
			if ("parentIFrame" in window) {
				window.parentIFrame.sendMessage(["REDIRECT_TO", url]);
			} else {
				this.$inertia.visit(url);
			}
		},
	},
};
</script>
